import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Gracias a esta guía pude cambiar mi manera de hablarle antes y después de los partidos, y eso mejoró mucho su confianza.',
    name: 'Laura G.'
  }, {
    quote: 'Me hizo ver que muchas veces, con buena intención, terminaba presionando más de lo que ayudaba. Fue un antes y un después.',
    name: 'Gustavo M.'
  }, {
    quote: 'Encontré herramientas simples pero muy útiles para apoyar a mi hijo en los momentos en que más se frustraba con el fútbol.',
    name: 'Andrea C.'
  }, {
    quote: 'Después de leerlo, pude acompañar a mi hijo con más calma, más criterio y menos ansiedad en cada partido.',
    name: 'Natalia P.'
  }, {
    quote: 'Me ayudó a entender que competir mejor no siempre es meter más presión, sino dar un apoyo más inteligente y más humano.',
    name: 'Federico T.'
  }, {
    quote: 'Nos sirvió mucho como familia porque empezamos a vivir el fútbol con menos tensión y con una mirada mucho más sana.',
    name: 'Paula N.'
  }];
  return <section className="py-20 md:py-28 bg-white" data-id="element-217">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-218">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-12 md:mb-16" data-id="element-219">
          <h2 className="text-3xl md:text-4xl font-heading text-brand-slate mb-4 leading-tight" data-id="element-220">
            Lo que dicen las familias que ya lo tienen
          </h2>
          <div className="flex justify-center items-center gap-1 mb-4" data-id="element-221">
            {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 fill-brand-amber text-brand-amber" data-id="element-222" />)}
          </div>
          <p className="text-base md:text-lg text-brand-slate-light" data-id="element-223">
            Basado en la experiencia de cientos de padres.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-224">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-white p-6 md:p-8 rounded-2xl border border-gray-100 flex flex-col h-full" data-id="element-225">
              <QuoteIcon className="w-6 h-6 text-gray-200 mb-4" data-id="element-226" />

              <div className="flex mb-4" data-id="element-227">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-3.5 h-3.5 fill-brand-amber text-brand-amber" data-id="element-228" />)}
              </div>

              <p className="text-base text-brand-slate-light leading-relaxed mb-6 flex-grow" data-id="element-229">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center mt-auto pt-4 border-t border-gray-50" data-id="element-230">
                <div className="w-10 h-10 rounded-full flex items-center justify-center font-medium text-sm mr-3 bg-[#f8f9fa] text-brand-slate" data-id="element-231">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-232">
                  <p className="font-medium text-brand-slate text-sm" data-id="element-233">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-brand-slate-muted" data-id="element-234">
                    Padre/Madre verificado
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}